import React from "react"
import styled from "styled-components"
import { navigate } from "gatsby"

import { PageContext } from "../models/contentful"
import { getTranslation } from "../utils/translations"

import {
  BorderRadius,
  Color,
  Spacing,
  Typography,
} from "@persona-id/design-tokens"
import { Paragraph } from "@persona-id/design-system/components/Text"
import Spacer from "@persona-id/design-system/components/Spacer"

const NavigationLeftEnterpriseEndUser = ({
  pageContext,
}: {
  pageContext: PageContext
}) => {
  const enterpriseEndUserArticle =
    pageContext.contentfulEnterpriseEndUserArticle

  return (
    <>
      <NavigationLeftSubheading>
        {getTranslation(enterpriseEndUserArticle?.locale?.code, "About")}
      </NavigationLeftSubheading>
      <Spacer height={1} />
      <Paragraph
        size="md"
        color="secondary"
        dangerouslySetInnerHTML={{
          __html:
            // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
            enterpriseEndUserArticle.enterprise_customer[0].description
              .childMarkdownRemark.html,
        }}
      ></Paragraph>
      <Spacer height={2} />
      <NavigationLeftSubheading>
        {getTranslation(enterpriseEndUserArticle?.locale?.code, "Articles")}
      </NavigationLeftSubheading>
      {enterpriseEndUserArticle.enterprise_customer[0].enterpriseEndUserArticles.map(
        article => {
          const { enterprise_customer: enterpriseCustomer, locale } =
            enterpriseEndUserArticle

          return (
            <NavigationLeftLink
              key={`navigation-left-enterprise-end-user-article-${article.contentful_id}`}
              onClick={() => {
                navigate(
                  `/${locale.code}/end-users/${enterpriseCustomer[0].slug}/${article.slug}`
                )
              }}
            >
              {article.title}
            </NavigationLeftLink>
          )
        }
      )}
    </>
  )
}

const NavigationLeftSubheading = styled.h2`
  ${Typography.TextLargeBold};
  margin: 0px 0px ${Spacing[1]} 0px;
`

const NavigationLeftLink = styled.div`
  ${Typography.TextMedium};
  display: flex;
  flex-direction: row;
  column-gap: ${Spacing[2]};
  align-items: center;
  margin-left: -${Spacing[2]};
  padding: ${Spacing[2]};
  border-radius: ${BorderRadius.Sm};
  cursor: pointer;

  :hover {
    color: ${Color.CorePurple800};
    background-color: ${Color.CorePurple100};
  }
`

export default NavigationLeftEnterpriseEndUser
